<script type="text/jsx">
import NextCharge from './next.vue';
import _ from 'lodash';
import { subscriptionLevelActionEnum } from '@/views/config/coupon/helper/constant';
import { mapGetters } from 'vuex';

export default {
  name: 'TodaysTotal',
  mixins: [NextCharge],
  computed: {
    ...mapGetters(['couponState', 'accountWithCouponDiscount', 'basicConfig']),
    needCallNextChargeDateApi() {
      return false;
    },
    nextCharge4CouponCondition() {
      if (this.$context.is.buyTrial
        || this.$context.is.add2trial
        || this.$context.is.buyNow
        || this.$context.is.basic2pro
      ) {
        return false;
      }

      // keep original logic, show today's total (for replace subscription)
      if (this.couponState.subscriptionLevelAction === subscriptionLevelActionEnum.replaceSubscription) {
        return false;
      }

      // keep original logic, account have forever coupon
      if (this.basicConfig?.hasAccountDiscount) {
        return false;
      }

      // keep original logic, show today's total (new annual/new monthly)
      if (this.totalPanelList?.length > 1) {
        return false;
      }

      // with coupon case for paid account (edit, upgrade, downgrade cases)
      if (this.accountWithCouponDiscount) {
        return true;
      }

      return false;
    },
  },
  render() {
    if (this.nextCharge4CouponCondition) {
      const elementNode = _.map(this.totalPanelList, (totalItem) => {
        return <div key={totalItem.billingCycle} class="opc-cart__next-charge-coupon--inner">
          <h3 class="opc-cart__submit__label--left">{totalItem.label}</h3>
          <h3 class="opc-cart__submit__label--right">
            <vloader loading={this.chargeAmountLoading} value={this.$money(totalItem.amount)} />
          </h3>
        </div>;
      });

      return <div class="opc-cart__submit__label">{elementNode}</div>;
    }

    return <div class="opc-cart__submit__label">{this.$slots.default || null}</div>;
  },
};
</script>

<style lang="scss">
.opc-cart__next-charge-coupon {
  &--inner {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
}
</style>
